<template>
  <div id="app">
    <div>
      <div id="nav">
        <div class="inner">
          <router-link to="/">
            <img id="home-menu-btn" src="./assets/EKSElement-home.svg" title="Zur Statistik" alt="Zur Statistik">
          </router-link>
          <Backbutton />
          <span style="display: none">{{ $t('title') }}</span>

          <PunkteCounterTop />

          <div v-if="loading">
            loading...
          </div>
          <span class="languages">
            <span style="margin-right: 10px" @click="changeLocale('de')">
              <img src="./assets/de.svg" title="Deutsch" alt="Deutsch">
            </span>
            <span class="trenner">
              <img id="trenner_lang" src="./assets/linie-vertikal.svg" title="Trenner" alt="Trenner" style="max-width: 1px">
            </span>
            <span style="margin-right: 10px;" @click="changeLocale('pl')">
              <img src="./assets/pl.svg" title="Polish" alt="Polish">
            </span>
            <span class="trenner">
              <img id="trenner_lang" src="./assets/linie-vertikal.svg" title="Trenner" alt="Trenner" style="max-width: 1px">
            </span>
            <span style="margin-right: 10px;" @click="changeLocale('en')">
              <img src="./assets/en.svg" title="English" alt="English">
            </span>
          </span>
        </div>
      </div>

      <template v-if="this.$root.hasaccess == false && Object.keys(this.$root.logincontent).length">
        <div class="login">
          <template v-if="!showticketform && !showticketformconfirmation">
            <h1 v-html="logincontent.ueberschrift.text" />
            <h2 v-html="logincontent.subueberschrift.text" />
            <p v-html="logincontent.text.text" />

            <div class="formular">
              <input ref="idpwd" value="" type="password" @keyup.enter="verifyLogin">
              <button type="button" style="cursor: pointer" @click="verifyLogin" v-html="logincontent.button.text" />
            </div>
          </template>

          <div v-if="!showticketform && !showticketformconfirmation" class="formular">
            <button type="button" style="cursor: pointer" @click="showticketform=true" v-html="logincontent.buybutton.text" />
          </div>

          <div v-if="showticketform && !showticketformconfirmation" class="formular">
            <h1 v-html="logincontent.ticketueberschrift.text" />
            <h3 v-html="logincontent.formticketlabel.text" />

            <input id="formticket" v-model="form['ticket']" type="radio" name="ticket" value="1" :checked="true" style="vertical-align: middle">
            <label for="formticket" style="vertical-align: middle" v-html="logincontent.formticketoption.text" />

            <h3 v-html="logincontent.formspendelabel.text" />

            <select v-model="form['spende']" name="spende" style="padding: 5px 10px; box-sizing: border-box">
              <option value="0" v-html="logincontent.formticketoptionfalse.text" />
              <option value="1.00">1 Euro</option>
              <option value="2.50">2.50 Euro</option>
              <option value="5.00">5 Euro</option>
              <option value="10.00">10 Euro</option>
              <option value="20.00">20 Euro</option>
              <option value="50.00">50 Euro</option>
              <option value="100.00">100 Euro</option>
              <option value="200.00">200 Euro</option>
              <option value="250.00">250 Euro</option>
            </select>

            <br>
            <br>
            <button type="button" style="cursor: pointer" @click="showticketformconfirmationlayout" v-html="logincontent.formbuttonformconfirmation.text" />
          </div>

          <div v-if="!showticketform && showticketformconfirmation" class="formular">
            <form action="orders/paypalpurchase" method="post">
              <input type="hidden" name="spende" :value="form['spende']">

              <h1 v-html="logincontent.ticketuebersichtueberschrift.text" />
              <h2 v-html="logincontent.ticketuebersichtsubueberschrift.text" />

              <div style="margin-top: 10px">
                <h3>Zahlungsart</h3>
                <img src="./assets/de-pp-logo-200px.png">
              </div>

              <h3 v-html="logincontent.formticketlabel.text" />
              <label style="vertical-align: middle" v-html="logincontent.formticketoption.text" /><small>*</small>

              <template v-if="form['spende'] != 0">
                <h3 v-html="logincontent.formspendelabel.text" />

                <label>{{ form['spende'] }} Euro</label><small>**</small>
              </template>


              <div style="margin-top: 10px">
                <h3>Gesamtpreis</h3>
                <b>{{ summe }}</b>
              </div>

              <div style="margin-top: 20px">
                <input id="widerruf" type="checkbox" name="widerruf_cbx" value="checked" required> <label for="widerruf" style="margin-left: 10px">Hiermit stimme ich den
                  <a href="#/wr" target="_blank">Widerufsbedingungen</a> zu und verstehe das mein Widerufsrecht erlischt sobald ich den Kauf abgeschlossen
                  habe.</label>
              </div>

              <div style="margin-top: 40px;">
                <h2 v-html="logincontent.hinweistextueberschrift.text" />
                <div class="hinweise" style="padding-left: 20px;box-sizing: border-box" v-html="logincontent.hinweistext.text" />
                <div class="hinweise">
                  <br>
                  * der Ticketpreis setzt sich aus dem Eintrittsticket für {{ logincontent.ticketdetails.preis }} Euro
                  zu {{ logincontent.ticketdetails.tax }}% Mwst und der Nutzungsgebühr für die App mit
                  {{ logincontent.appdetails.preis }} Euro zu {{ logincontent.appdetails.tax }}% Mwst zusammen.<br>
                  ** der Spendenbetrag wird mit 0% Mwst besteuert
                </div>
              </div>

              <br>
              <br>
              <button type="button" style="cursor: pointer" @click="showticketform=true;showticketformconfirmation=false;" v-html="logincontent.formbuttonbackformconfirmationoverview.text" />
              <button type="submit" style="cursor: pointer" v-html="logincontent.formbuttonpurchaseformconfirmationoverview.text" />
            </form>
          </div>
        </div>
      </template>

      <transition v-if="this.$root.hasaccess == true" :name="transitionName">
        <router-view />
      </transition>
    </div>

    <div class="pre-footer">
      <div class="row1">
        <div>
          <a href="http://www.evkulturstiftunggr.de/" target="_blank"><img src="./assets/signet_gross.jpeg"></a>
        </div>
      </div>
      <div class="row2">
        <div>
          <a href="https://www.bundesregierung.de/breg-de/bundesregierung/staatsministerin-fuer-kultur-und-medien" target="_blank"><img src="./assets/BKM_Logo-Footer.png"></a>
        </div>
      </div>
    </div>

    <footer>
      <router-link to="/ds">Datenschutz</router-link>
      |
      <router-link to="/about">Impressum</router-link>
      |
      <router-link to="/wr">Widerruf</router-link>
    </footer>
  </div>
</template>

<script type="text/babel">
import Backbutton from './components/Backbutton'
import PunkteCounterTop from './components/PunkteCounterTop'
import axios from 'axios'

export default {
  name: 'Home',
  components: {
    PunkteCounterTop,
    Backbutton,
  },
  data: function () {
    return {
      transitionName: 'fade',
      showticketform: false,
      showticketformconfirmation: false,
      form: {
        spende: 0,
        ticket: 1,
      },
    }
  },
  computed: {
    loading() {
      return this.$root.loading
    },
    language: function () {
      return this.$root.$i18n.locale
    },
    logincontent: function () {
      return this.$root.logincontent[this.language]
    },
    summe: function () {
      console.log(this.logincontent.appdetails.preis)
      console.log(parseFloat(this.logincontent.appdetails.preis).toFixed(2))

      let sum = parseFloat(this.form['ticket']) * ( parseFloat(this.logincontent.ticketdetails.preis) + parseFloat(this.logincontent.appdetails.preis) )

      sum+= parseFloat(this.form['spende'])

      return sum.toFixed(2) + ' Euro'
    },
  },
  watch: {
    '$route'(to, from) {
      let transitionName = ''
      const toDepth = to.path.split('/').length
      const fromDepth = from.path.split('/').length
      transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
      this.transitionName = transitionName || 'fade'
      //console.log(this.transitionName)
    },
  },
  methods: {
    changeLocale(locale) {
      this.$i18n.locale = locale
      // i18n.locale = locale;
    },
    verifyLogin() {

      let pwd = this.$refs.idpwd.value.toLowerCase()

      axios
        .get(process.env.VUE_APP_API_ENDPOINT + 'codes/api?code=' + pwd)
        .then(response => {
          //console.log(response.data);

          if (response.data) {
            let ldate = new Date().toLocaleDateString()
            localStorage.setItem('logindate', ldate)
            this.$root.loginaccess = true
          } else {
            localStorage.setItem('logindate', '')
            this.$root.loginaccess = false
          }
        })
        .catch(error => {
          //console.log(error)
          this.errored = true
        })
        .finally(() => this.loading = false)
    },
    showticketformconfirmationlayout() {
      this.showticketform = false
      this.showticketformconfirmation = true


    },
  },
}
</script>

<style lang="scss">
@import "./assets/default.scss";
</style>

<style scoped lang="scss">
.login {
  max-width: 1024px;
  margin: 0 auto;
  padding: 30px;

  h2 {
    color: #350f37
  }
}

ul li {
  margin-left: 20px;
  margin-bottom: 5px;
}

h1 {
  border-color: white;
}

h3 {
  margin-top: 20px;
  margin-bottom: 10px;
}

h2 {
  margin-top: 20px;
  margin-bottom: 10px;
  color: white;
}

.formular {
  padding-top: 20px;
  box-sizing: border-box;

  input[type="password"] {
    padding: 15px 20px;
    box-sizing: border-box;
    vertical-align: middle;
    border: 0;
    height: 50px;
    color: #350f37;
  }

  button {
    border: 0;
    background-color: #350f37;
    color: white;
    font-weight: bold;
    margin-left: 0;
    vertical-align: middle;
    height: 50px;
    font-family: 'Source Sans Pro', sans-serif;

    a {
      color: white;
    }
  }

  input[type="radio"] {
    margin-right: 10px;
  }
}
</style>

<style lang="scss" scoped>
#nav {
  padding: 10px 20px;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  background-color: #350f37;
  backdrop-filter: blur(5px);
  z-index: 1002;

  @media screen and (max-width: 480px) {
    padding: 0px 20px;
  }

  .inner {
    max-width: 1024px;
    margin: 0 auto;

    @media screen and (max-width: 480px) {
      padding-bottom: 6px;
    }
  }
}

.languages img {
  width: 50px;
  cursor: pointer;

  @media screen and (max-width: 480px) {
    width: 30px;
    margin-top: 6px;
  }

  @media screen and (max-width: 340px) {
    width: 20px;
    margin-top: 10px;
    box-sizing: border-box;
  }
}

.trenner {
  @media screen and (max-width: 340px) {
    display: none;
  }
}

#home-menu-btn {
  max-width: 33px;
  margin-top: 0;
  margin-bottom: 2px;

  @media screen and (max-width: 480px) {
    max-width: 22px;
    margin-top: 6px;
  }
}

.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.5s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  transform: translate(6em, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  transform: translate(-6em, 0);
}

#trenner_lang {
  margin-right: 10px;
  height: 37px;

  @media screen and (max-width: 480px) {
    margin-right: 10px;
    height: 22px;
  }
}

button {
  padding: 15px;
  border: 1px solid green;
  font-size: 18px;
  margin: 15px;
}

.pre-footer {
  background-color: white;
}
</style>
